import { Col, Container, Row } from "react-bootstrap"
import { SwiperAfisha } from "../UI/SwiperAfisha"
import { Helmet } from "react-helmet"
import { useGetAfishaQuery } from "../../features/CallApi"
import { LoadScreenMin } from "../UI/LoadScreenMin"
import { Repertoire } from "../Show/Repertoire"
import { Exhibitions } from "../Exhibition/Exhibitions"
import { useTranslation } from "react-i18next"
import { Suspense } from "react"
import ContentLoader from "react-content-loader"
import { AfishaHome } from "./AfishaHome"




export const Afisha = ({ selLanguage }) => {

    const [t] = useTranslation("global");

    return (
        <>
            <Helmet>
                <title>{`${t("menu.tickets")} - ${t("mainTag.title")}`}</title>
                <meta name="description" content='Первое в России шоу-пространство "Ленинград Центр"' />
                <meta name="og:title" content={`${t("menu.tickets")} - ${t("mainTag.title")}`} />
                <meta name="og:description" content='Первое в России шоу-пространство "Ленинград Центр"' />
                <meta name="keywords" content="шоу- пространство, шоу пространство, ленинград центр, центр ленинград, мюзикл, шоу, представление, афиша"></meta>
                {/* <meta property="og:image" content={data.headLayoutImageType ? `/api/shows/head-wide-img/${data.id})` : "/Show/091A8332.jpg"} /> */}
            </Helmet>
            <div className="news-haed-layout">
                <div className="news-head-layout-img" style={{ backgroundImage: 'url("/News/news.jpg")' }}>
                </div>
                <div className="news-head-mask">
                    <div className="justify-content-end ms-auto me-auto justify-content-end rounded-3" style={{ width: "70%", backgroundColor: "#00000006", padding: "1rem" }}>
                        <div className="text-white ms-auto justify-content-end">
                            <div className="h1 text-center">{t("menu.tickets")}</div>
                        </div>
                    </div>
                </div>
            </div>
            <Container>
                <Suspense fallback={<LoadScreenMin height={100} />}>
                    <AfishaHome />
                </Suspense>
                {/* <Exhibitions maxCount={1} /> */}
            </Container>
        </>

    )
}